import{_ as o}from"./_baseGetTag.js";import{i as r}from"./isObjectLike.js";var t=o,e=r,s="[object Symbol]";var a=function(o){return"symbol"==typeof o||e(o)&&t(o)==s};export{a as i};
//# sourceMappingURL=isSymbol.js.map
